import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeTaskDetailsFiltering } from './Pages';

export const EmployeeTaskDetailsRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={EmployeeTaskDetailsFiltering} />
    </Fragment>
)